import lonCategoryApi from '@/api/lon-category'

const SET_CATEGORY_OPTIONS = 'SET_CATEGORY_OPTIONS'

const namespaced = true

let categoryOptionsLoaded = false

const state = {
  categoryOptions: []
}

const mutations = {
  [SET_CATEGORY_OPTIONS](state, payload) {
    state.categoryOptions = payload
  }
}

const actions = {
  async fetchCategoryOptions({ commit, rootGetters }, forceUpdate = false) {
    if (categoryOptionsLoaded && !forceUpdate) return

    const { pageid } = rootGetters.selectedBot

    try {
      const response = await lonCategoryApi.getCategories({
        page_id: pageid,
        limit: 1000,
        offset: 0
      })

      const { data } = response.data

      const mappedOptions = data.map((item) => ({
        value: item.id,
        text: item.lon_category_name
      }))

      commit(SET_CATEGORY_OPTIONS, mappedOptions)

      categoryOptionsLoaded = true
    } catch (error) {
      console.error(error)
    }
  }
}

export default {
  namespaced,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/lon.js